// extracted by mini-css-extract-plugin
module.exports = {"CustomTourBannerImage":"styles_CustomTourBannerImage__1ASvk"};